import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import DateInput from '../../../../components/form/date/DateInput'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import GalleryInput from '../../../../components/form/GalleryInput'
import Textarea from '../../../../packages/kiti/components/form/Textarea'
import UsersOrGroupsSelect from '../../../../containers/users/select/UsersOrGroupsSelect'

const GeneralSection = () => {
  const {
    data: { placeId }
  } = useCurrentModal()

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem
          label="O que será feito?*"
          field="checklist"
          Input={ChecklistSelect}
          filter={{
            placeIds: placeId,
            usages: ['actionPlan']
          }}
        />
      </Col>

      <Col width="100%">
        <FormItem label="Quem é o responsável?*" field="userOrGroup" Input={UsersOrGroupsSelect} />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label="Quando será feito?" field="scheduling" Input={DateInput} useTime />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label="Descrição" field="description" Input={Textarea} limit={255} rows={2} />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label="Documentos" field="documents" Input={GalleryInput} thumbHeight="8rem" colWidth="50%" />
      </Col>
    </Grid>
  )
}

export default GeneralSection
